import logoIcon from '../../backgroundImages/logo.webp';
import { BRAND_NAME_TM, TRADEMARK_SYMBOL } from '../../constants/brand';

const DEFAULT_TM_CLASS = '-bottom-px -right-1 text-[0.4rem]';

const Logo = ({
  className = '',
  alt = BRAND_NAME_TM,
  showTrademark = true,
  tmClassName = DEFAULT_TM_CLASS,
  imgClassName = '',
}) => (
  <span className={`relative inline-block leading-none ${className}`}>
    <img
      src={logoIcon}
      alt={alt}
      className={`block w-full h-full object-contain ${imgClassName}`}
    />
    {showTrademark && (
      <span
        aria-hidden="true"
        className={`absolute font-semibold leading-none text-foreground/90 pointer-events-none select-none ${tmClassName}`}
      >
        {TRADEMARK_SYMBOL}
      </span>
    )}
  </span>
);

export default Logo;
